import usePrivateLink from "../config/usePrivateLink";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./HostelHeader";
import Nav from "../master/NavBar";
import Footer from "../main/footer";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import "react-calendar/dist/Calendar.css";
import {
  GetCollectionReport,
  GetDueFeeReport,
  GetExpenseReport,
  GetReport,
} from "../../api/HostelService";
import WelcomeBar from "./WelcomeBar";
import { ExpenseCategoryList } from "../../api/HostelExpenses";
import { getSessions } from "../../api/SessionsService";
import { StaffList } from "../../api/Staff";
import HostelReportTabs from "./HostelReportTabs";

export default function Reports() {
  const hasAccess = usePrivateLink();
  const [activeTab, setActiveTab] = useState("overview");
  const [page, setPage] = useState(1);
  const [Data, setData] = useState(null);
  const [total, setTotal] = useState(0);
  const [staffs, setStaffs] = useState([]);
  const [from, setFrom] = useState("");
  const [searchExpense_id, setSearchExpenseId] = useState("");
  const [name, setName] = useState("");
  const [to, setTo] = useState("");
  const [batchId, setBatchID] = useState("");
  const [staffId, setStaffId] = useState("");
  const [loading, setLoading] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [selectedSession, setSelectedSessions] = useState("");
  const [sessions, setSessions] = useState([]);
  const [error, setError] = useState("");

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response?.data?.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1",
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
        // setSessions(activeSessions);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const getExpenseCategory = async () => {
    setLoading(true);
    try {
      const response = await ExpenseCategoryList();
      if (response.data.status) {
        setExpenses(response?.data?.data);
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const [hostel_id, setHostelId] = useState(localStorage.getItem("hostel_id"));
  useEffect(() => {
    const handleStorageChange = () => {
      setHostelId(localStorage.getItem("hostel_id"));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const loadOnce = useRef(false);
  const fetchData = async () => {
    let addUrl = `&page=${page}&session_id=${selectedSession}`;
    if (searchExpense_id) addUrl += `&expense_id=${searchExpense_id}`;
    if (from) addUrl += `&start_date=${from}`;
    if (to) addUrl += `&end_date=${to}`;
    if (batchId) addUrl += `&batch_id=${batchId}`;
    if (staffId) addUrl += `&staff_id=${staffId}`;
    if (name) addUrl += `&search=${name}`;
    if (hostel_id) addUrl += `&hostel_id=${hostel_id}`;
    try {
      let response;

      if (activeTab == "collection") {
        response = await GetCollectionReport(addUrl);
      } else if (activeTab == "expense") {
        response = await GetExpenseReport(addUrl);
      } else if (activeTab == "feeDues") {
        response = await GetDueFeeReport(addUrl);
      } else {
        response = await GetReport(addUrl);
      }

      setData(response?.data?.data);
      setTotal(response?.data?.total_sum);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    }
  };

  const getStaffs = async () => {
    setLoading(true);
    try {
      let response = await StaffList();
      setStaffs(response?.data?.batches);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStaffs();
  }, []);

  useEffect(() => {
    setPage(1);
    setFrom("");
    setTo("");
    setStaffId("");
    setBatchID("");
  }, [activeTab]);

  useEffect(() => {
    fetchData();
    getExpenseCategory();
  }, [
    activeTab,
    page,
    from,
    to,
    batchId,
    staffId,
    name,
    searchExpense_id,
    selectedSession,
  ]);

  useEffect(() => {
    if (!loadOnce.current && Data?.all && activeTab == "overview") {
      const existingScript = document.querySelector(
        'script[src="/assets/js/report.js"]',
      );
      if (existingScript) {
        existingScript.remove();
      }

      // totalProfitChart
      window.DasChartCategories = Data?.all?.summary?.months || [];
      window.PresentStudent = Data?.all?.summary?.collection || [];
      window.AbsentStudent = Data?.all?.summary?.expenses || [];

      window.DasChartCategories2 = Data?.last_week?.summary?.days || [];
      window.PresentStudent2 = Data?.last_week?.summary?.collection || [];
      window.AbsentStudent2 = Data?.last_week?.summary?.expenses || [];

      window.DasChartCategories3 = [];
      window.PresentStudent3 = [];
      window.AbsentStudent3 = [];

      window.DasChartCategories4 = Data?.attendance?.days || [];
      window.PresentStudent4 = Data?.attendance?.staff?.present || [];
      window.AbsentStudent4 = Data?.attendance?.staff?.absent || [];

      window.CollectionExpense = ["Collection", "Expense"];
      window.CollectionExpenseData = [
        Number(Data?.all?.collection),
        Number(Data?.all?.expense),
      ];
      window.CollectionExpenseStatus = Data?.all?.status;
      window.CollectionExpenseStatusData = Data?.all?.value;

      window.BatchList = Data?.batchWise?.batch || [];
      window.BatchDeu = Data?.batchWise?.pending || [];
      window.BatchTotal = Data?.batchWise?.final || [];

      const script = document.createElement("script");
      script.src = "/assets/js/report.js";
      script.async = true;
      document.body.appendChild(script);
      loadOnce.current = true;
    }
  }, [Data, activeTab]);
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <>
                {/* Content */}
                <div className="container-xxl flex-grow-1 container-p-y">
                  <WelcomeBar />
                  <HostelReportTabs />
                  {activeTab === "overview" && (
                    <div className="row gy-6">
                      {/* Total Transactions & Report Chart */}
                      <div className="col-12 col-xl-8">
                        <div className="card h-100">
                          <div className="row">
                            <div className="col-md-7 pe-md-0">
                              <div className="card-header">
                                <h5 className="mb-0 text-primary fw-semibold">
                                  Financial Year Report
                                </h5>
                              </div>
                              <div className="card-body">
                                <div id="totalProfitChart" />
                              </div>
                            </div>
                            <div className="col-md-5 border-start ps-md-0">
                              <hr className="d-block d-md-none my-0" />
                              <div className="card-header">
                                <div className="d-flex justify-content-between">
                                  <h5 className="mb-0 text-primary">
                                    {Data?.total_students}
                                  </h5>
                                  <div className="dropdown">
                                    <button
                                      className="btn text-muted p-0"
                                      type="button"
                                      id="totalProfit"
                                      data-bs-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      <i className="ri-more-2-line ri-24px" />
                                    </button>
                                    <div
                                      className="dropdown-menu dropdown-menu-end"
                                      aria-labelledby="totalProfit"
                                    >
                                      <a
                                        className="dropdown-item"
                                        href="javascript:void(0);"
                                      >
                                        Last 28 Days
                                      </a>
                                      <a
                                        className="dropdown-item"
                                        href="javascript:void(0);"
                                      >
                                        Last Month
                                      </a>
                                      <a
                                        className="dropdown-item"
                                        href="javascript:void(0);"
                                      >
                                        Last Year
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <p className=" mb-0">
                                  Total Students {Data?.all?.total_student}
                                </p>
                              </div>
                              <div className="card-body pt-3">
                                <div className="d-flex align-items-center mb-4">
                                  <div className="avatar">
                                    <div className="avatar-initial bg-label-primary rounded">
                                      <i className="ri-wallet-line ri-24px" />
                                    </div>
                                  </div>
                                  <div className="ms-3 d-flex flex-column">
                                    <h6 className="mb-1 text-primary fw-semibold">
                                      ₹ {Data?.all?.collection}
                                    </h6>
                                    <p className="mb-0">Total Collection</p>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center mb-4">
                                  <div className="avatar">
                                    <div className="avatar-initial bg-label-info rounded">
                                      <i className="ri-bank-card-line ri-24px" />
                                    </div>
                                  </div>
                                  <div className="ms-3 d-flex flex-column">
                                    <h6 className="mb-1 text-info fw-semibold">
                                      ₹ {Data?.all?.expense}
                                    </h6>
                                    <p className="mb-0">Total Expense</p>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center mb-4">
                                  <div className="avatar">
                                    <div className="avatar-initial bg-label-danger rounded">
                                      <i className="ri-group-fill ri-24px" />
                                    </div>
                                  </div>
                                  <div className="ms-3 d-flex flex-column">
                                    <h6 className="mb-1 text-danger fw-semibold">
                                      ₹ {Data?.all?.left_amount}
                                    </h6>
                                    <p className="mb-0 ">Total Due Fees</p>
                                  </div>
                                </div>
                                <div>
                                  <button
                                    className="btn btn-primary w-100"
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#report"
                                  >
                                    View Report
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*/ Total Profit Chart & Last month balance */}
                      {/* Total Visitors Chart */}
                      <div className="col-xl-4 col-md-6">
                        <div className="card h-100">
                          <div className="card-header pb-1">
                            <div className="d-flex justify-content-between">
                              <h5 className="mb-0 text-primary fw-semibold">
                                Financial Year Profit & lose
                              </h5>
                              <div className="dropdown">
                                <button
                                  className="btn text-muted p-0"
                                  type="button"
                                  id="totalRevenueDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <i className="ri-more-2-line ri-24px" />
                                </button>
                                <div
                                  className="dropdown-menu dropdown-menu-end"
                                  aria-labelledby="totalRevenueDropdown"
                                >
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Last 28 Days
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Last Month
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Last Year
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-body">
                            <div id="salesOverviewChart"></div>
                          </div>
                        </div>
                      </div>
                      {/*/ Total Visitors Chart */}
                      {/* Weekly Sales Chart */}
                      <div className="col-xl-8 col-md-6">
                        <div className="card h-100">
                          <div className="card-header">
                            <div className="d-flex justify-content-between">
                              <h5 className="mb-0 text-primary fw-semibold">
                                Last 7 Days Report
                              </h5>
                              <div className="dropdown">
                                <button
                                  className="btn text-muted p-0"
                                  type="button"
                                  id="weeklySalesDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <i className="ri-more-2-line ri-24px" />
                                </button>
                                <div
                                  className="dropdown-menu dropdown-menu-end"
                                  aria-labelledby="weeklySalesDropdown"
                                >
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Last 28 Days
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Last Month
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Last Year
                                  </a>
                                </div>
                              </div>
                            </div>
                            <p className="text-mute mb-0">
                              7 Days Expances & Collection
                            </p>
                          </div>
                          <div className="card-body">
                            <div id="totalProfitChart2" />
                          </div>
                        </div>
                      </div>
                      {/*/ Weekly Sales Chart */}

                      {/* Last 7 days chart*/}
                      <div className="col-xl-4 col-md-6">
                        <div className="card border-start ps-md-0">
                          <hr className="d-block d-md-none my-0" />
                          <div className="card-header">
                            <div className="d-flex justify-content-between">
                              <h5 className="mb-0 text-primary fw-semibold">
                                Last 7 Today`s Collection{" "}
                              </h5>
                              <div className="dropdown">
                                <button
                                  className="btn text-muted p-0"
                                  type="button"
                                  id="totalProfit"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <i className="ri-more-2-line ri-24px" />
                                </button>
                                <div
                                  className="dropdown-menu dropdown-menu-end"
                                  aria-labelledby="totalProfit"
                                >
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Last 28 Days
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Last Month
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Last Year
                                  </a>
                                </div>
                              </div>
                            </div>
                            <p className=" mb-5">
                              Profit , Collection and Expenses
                            </p>
                          </div>
                          <div className="card-body pt-5">
                            {(() => {
                              const value =
                                Data?.last_week?.day_graph?.net?.reduce(
                                  (sum, val) => sum + val,
                                  0,
                                ) || 0;

                              return (
                                <>
                                  <div className="d-flex align-items-center mb-5 mt-3">
                                    <div className="avatar">
                                      <div
                                        className={`avatar-initial  rounded ${
                                          Data?.last_week?.status == "Profit"
                                            ? "bg-label-success"
                                            : "bg-label-danger"
                                        }`}
                                      >
                                        <i
                                          className={`${
                                            Data?.last_week?.status == "Profit"
                                              ? "ri-arrow-up-line"
                                              : "ri-arrow-down-line"
                                          } ri-24px`}
                                        ></i>
                                      </div>
                                    </div>
                                    <div className="ms-3 d-flex flex-column">
                                      <h6 className="mb-1 text-primary fw-semibold">
                                        ₹ {Data?.last_week?.value}
                                      </h6>
                                      <p className="mb-0">
                                        {Data?.last_week?.status}
                                      </p>
                                    </div>
                                  </div>
                                </>
                              );
                            })()}

                            {/* Total Collection */}
                            <div className="d-flex align-items-center mb-5">
                              <div className="avatar">
                                <div className="avatar-initial bg-label-primary rounded">
                                  <i className="ri-money-dollar-circle-line ri-24px" />{" "}
                                  {/* Collection icon */}
                                </div>
                              </div>
                              <div className="ms-3 d-flex flex-column">
                                <h6 className="mb-1 text-primary fw-semibold">
                                  ₹ {Data?.last_week?.collection}
                                </h6>
                                <p className="mb-0">Total Collection</p>
                              </div>
                            </div>

                            {/* Total Expense */}
                            <div className="d-flex align-items-center mb-5">
                              <div className="avatar">
                                <div className="avatar-initial bg-label-secondary rounded">
                                  <i className="ri-wallet-3-line ri-24px" />{" "}
                                  {/* Expense icon */}
                                </div>
                              </div>
                              <div className="ms-3 d-flex flex-column mb-5">
                                <h6 className="mb-1 text-primary fw-semibold">
                                  ₹ {Data?.last_week?.expenses}
                                </h6>
                                <p className="mb-0">Total Expense</p>
                              </div>
                            </div>

                            <div className="mt-5">
                              {/* <button
                                className="btn btn-primary w-100"
                                type="button"
                              >
                                View Report
                              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*/ Last 7 days chart*/}
                      {/* Teacher Attendance Chart */}
                      {/* <div className="col-xl-12">
                        <div className="card h-100">
                          <div className="card-header">
                            <div className="d-flex justify-content-between">
                              <h5 className="mb-1 text-primary fw-semibold">
                                Weekly Faculty Presence Report
                              </h5>
                              <div className="dropdown">
                                <button
                                  className="btn text-muted p-0"
                                  type="button"
                                  id="weeklyOverviewDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <i className="ri-more-2-line ri-24px"></i>
                                </button>
                                <div
                                  className="dropdown-menu dropdown-menu-end"
                                  aria-labelledby="weeklyOverviewDropdown"
                                >
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Refresh
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Share
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0);"
                                  >
                                    Update
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-body pt-0">
                            <div id="totalProfitChart3" />
                          </div>
                        </div>
                      </div> */}
                    </div>
                  )}
                </div>
              </>
              <Footer />
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="report"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <form>
              <div className="modal-header bg-label-primary py-3">
                <h1 className="modal-title fs-5">Reports View</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-4 col-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-select"
                        name="session"
                        value={selectedSession}
                        onChange={(e) => setSelectedSessions(e.target.value)}
                      >
                        {/* <option value="">Select Session</option> */}
                        {sessions?.map((session) => (
                          <option key={session?.id} value={session?.id}>
                            {session?.session}:
                            {session?.status == "1" ? "Active" : " Inactive"}
                            {/* Show "2023-24" */}
                          </option>
                        ))}
                      </select>

                      <label>Filter Session</label>
                    </div>
                  </div>
                </div>
                {/* Data Summary (Aligned horizontally) */}
                <div className="row mb-4">
                  <div className="col-6 col-md-3 mt-2">
                    <div className="card p-3 text-center">
                      <h5 className="text-primary">
                        {Data?.all?.total_student}
                      </h5>
                      <p>Total Students</p>
                    </div>
                  </div>

                  <div className="col-6 col-md-3 mt-2">
                    <div className="card p-3 text-center">
                      <h5 className="text-success">
                        ₹ {Data?.all?.collection}
                      </h5>
                      <p>Total Collection</p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 mt-2">
                    <div className="card p-3 text-center">
                      <h5 className="text-danger">₹ {Data?.all?.expense}</h5>
                      <p>Total Expense</p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 mt-2">
                    <div className="card p-3 text-center">
                      <h5 className="text-danger">
                        ₹ {Data?.all?.left_amount}
                      </h5>
                      <p>Total Due Fees</p>
                    </div>
                  </div>
                </div>

                {/* Date Filters */}
                {/* <div className="row d-flex">
                  <div className="col-md-3 col-6 form-floating form-floating-outline">
                    <input
                      type="date"
                      id="fromDate"
                      className="form-control"
                      value={from}
                      onChange={e => setFrom(e.target.value)}
                    />
                    <label>From Date</label>
                  </div>
                  <div className="col-md-3 col-6 form-floating form-floating-outline">
                    <input
                      type="date"
                      id="toDate"
                      className="form-control"
                      value={to}
                      onChange={e => setTo(e.target.value)}
                    />
                    <label>To Date</label>
                  </div>
                  <div className="col-md-3 col-6 d-flex align-items-center">
                     <button
                      onClick={() => {
                        const today = new Date();
                        const sevenDaysAgo = new Date();
                        sevenDaysAgo.setDate(today.getDate() - 6);
                        const formatDate = (date) => date.toISOString().split("T")[0];
                        setTo(formatDate(today));
                        setFrom(formatDate(today));
                      }}
                      className="btn btn-sm btn-primary me-2"
                    >
                      Today
                    </button>
                    <button
                      onClick={() => {
                        const today = new Date();
                        const sevenDaysAgo = new Date();
                        sevenDaysAgo.setDate(today.getDate() - 6);
                        const formatDate = (date) => date.toISOString().split("T")[0];
                        setTo(formatDate(today));
                        setFrom(formatDate(sevenDaysAgo));
                      }}
                      className="btn btn-sm btn-primary"
                    >
                      7 Days
                    </button>
                  </div>

                </div> */}

                {/* Table to display filtered data */}
                <div className="table-responsive">
                  <table className="table text-center hovered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Session</th>
                        <th>Collection</th>
                        <th>Expense</th>
                        {/* <th>Pending Fees</th>
                        <th>Total Students</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {Data ? (
                        <tr>
                          <td>1</td>
                          <td>{Data.all?.session}</td>
                          <td>₹ {Data.all?.collection}</td>
                          <td>₹ {Data?.all?.expense || "0"}</td>
                          {/* <td>₹ {Data.pending_fees}</td>
                          <td>{Data.total_students}</td> */}
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center text-muted">
                            No data found for the selected date range
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Footer with Buttons */}
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
